import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from './guards/auth.guard';
import { AdminPageComponent } from './pages/admin/admin-page/admin-page.component';
import { CompartirPageComponent } from './pages/admin/compartir-page/compartir-page.component';
import { EliminarQuinielaPageComponent } from './pages/admin/eliminar-quiniela-page/eliminar-quiniela-page.component';
import { JugadoresPageComponent } from './pages/admin/jugadores-page/jugadores-page.component';
import { QuinielaPageComponent } from './pages/admin/quiniela-page/quiniela-page.component';
import { QuinielasPageComponent } from './pages/admin/quinielas-page/quinielas-page.component';
import { FAQPageComponent } from './pages/faqpage/faqpage.component';
import { InicioPageComponent } from './pages/inicio-page/inicio-page.component';
import { JugadorPageComponent } from './pages/jugador-page/jugador-page.component';
import { LlenadoPageComponent } from './pages/llenado-page/llenado-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { MenuPageComponent } from './pages/menu-page/menu-page.component';
import { MostrarQuinielaComponent } from './pages/mostrar-quiniela/mostrar-quiniela.component';
import { PagoPageComponent } from './pages/pago-page/pago-page.component';
import { PartidoPageComponent } from './pages/partido-page/partido-page.component';
import { RegisterPageComponent } from './pages/register-page/register-page.component';
import { ReportPageComponent } from './pages/report-page/report-page.component';
import { TablaPageComponent } from './pages/tabla-page/tabla-page.component';


const routes: Routes = [
  { path:'', component: InicioPageComponent },
  { path:'register', component: RegisterPageComponent },
  { path:'login', component: LoginPageComponent },
  { path:'menu', component: MenuPageComponent },
  { path:'quinielas', canActivate: [AuthenticationGuard], component: QuinielasPageComponent },
  { path:'eliminar', canActivate: [AuthenticationGuard], component: EliminarQuinielaPageComponent },
  { path:'quiniela/:id', canActivate: [AuthenticationGuard], component: QuinielaPageComponent },
  { path:'quiniela/:id/jugadores', canActivate: [AuthenticationGuard], component: JugadoresPageComponent },
  { path:'compartir/:id', canActivate: [AuthenticationGuard], component: CompartirPageComponent },
  { path:'participar/:id', component: LlenadoPageComponent },
  { path:'pago/:id', component: PagoPageComponent },
  { path:'tabla/:id', component: TablaPageComponent },
  { path:'jugador/:id', component:MostrarQuinielaComponent },
  { path:'partido/:id', component:PartidoPageComponent },
  { path:'report/bug', component:ReportPageComponent },
  { path:'faq/info', component: FAQPageComponent },
  { path:'administrar', canActivate: [AuthenticationGuard], component: AdminPageComponent },
  { path:':url', component: JugadorPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
